module.exports = __webpack_public_path__ + "static/img/icon_service_qr.ab3acad.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_service_qr.jpeg
// module id = a188
// module chunks = 1